import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../layout";
import { Button } from "../../controls";
import { Avatar, Divider, IconButton, Tooltip } from "@mui/material";
import {
  AccessibilityRounded,
  ClearRounded,
  EditRounded,
  PlayCircleFilledRounded,
  StopCircleRounded,
  VisibilityRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import UnfreezeForm from "../Freeze/UnfreezeForm";
import moment from "moment";
import { useTranslation } from "react-i18next";

const Members = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { branch, setLoader } = useContext(AppContext);
  const [showUnfreeze, setShowUnfreeze] = useState(false);
  const [memberDtls, setMemberDtls] = useState();
  const [members, setMembers] = useState([]);
  const [invs, setInvs] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setLoader(true);
    if (branch.id) {
      API(endpoints.Member + actions.GetAllByBranch).getById(
        branch.id,
        (res) => {
          res.status === 200 && setMembers([...res.result]);
          setLoader(false);
        }
      );
      API(endpoints.Invoice + actions.GetAllByBranch).getById(
        branch.id,
        (res) => {
          res.status === 200 &&
            setInvs([
              ...res.result.filter(
                (j) => j.invStatus !== 3 && j.invStatus !== 4
              ),
            ]);
          setLoader(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  useEffect(() => {
    if (members.length) {
      setMembers((x) => [
        ...x.map((j) => ({
          ...j,
          invs: invs.filter((y) => y.memberId === j.id),
        })),
      ]);
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invs]);

  const handleAddEdit = (id) => {
    navigate(`/member_form/${id || ""}`);
  };

  const handleView = (id) => {
    navigate(`/view_member_profile/${id}`);
  };

  const handleDlt = (id) => {
    if (id) {
      setAlert({
        isOpen: true,
        type: "confirmation",
        title: t("CfmTitle"),
        subTitle: t("MemberDltTitle"),
        onConfirm: () => {
          const onComplete = (res) => {
            if (res.status === 200) {
              setAlert({
                isOpen: true,
                type: "success",
                title: t("DltSuccessTitle"),
                subTitle: res.msg,
              });
              setMembers((x) => [...x.filter((j) => j.id !== res.result.id)]);
            } else {
              setAlert({
                isOpen: true,
                type: "warning",
                title: t("Warning"),
                subTitle: res.msg,
              });
            }
          };
          API(endpoints.Member).Delete(id, onComplete);
        },
      });
    }
  };

  const handleFreeze = (id) => {
    navigate(`/freeze_form/${id || ""}`);
  };

  const handleMeas = (id) => {
    navigate(`/member_measurement_form/${id || ""}`);
  };

  const handleUnfreeze = (data) => {
    setMemberDtls(data);
    setShowUnfreeze(true);
  };

  const Freezing = ({ value }) => {
    switch (value.accStatus) {
      case 1:
        return (
          <Tooltip title={t("FreezeMember")}>
            <IconButton
              onClick={() => handleFreeze(value.id)}
              size="small"
              color="error"
              className="mr-5 p-5"
            >
              <StopCircleRounded className="fs-20 m-2" />
            </IconButton>
          </Tooltip>
        );
      case 2:
        return (
          <Tooltip title={t("UnfreezeMember")}>
            <IconButton
              onClick={() => handleUnfreeze(value)}
              size="small"
              color="success"
              className="mr-5 p-5"
            >
              <PlayCircleFilledRounded className="fs-20 m-2" />
            </IconButton>
          </Tooltip>
        );
      default:
        break;
    }
  };

  const ActionComp = (val) => (
    <div className="bs-secondary br-8 p-5 w-fit p-2">
      <Tooltip title={t("View")}>
        <IconButton
          onClick={() => handleView(val.id)}
          size="small"
          color="primary"
          className="mr-5"
        >
          <VisibilityRounded className="fs-20 m-2" />
        </IconButton>
      </Tooltip>

      <Tooltip title={t("Edit")}>
        <IconButton
          onClick={() => handleAddEdit(val.id)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <EditRounded className="fs-20 m-2" />
        </IconButton>
      </Tooltip>
      <Tooltip title={t("Measurement")}>
        <IconButton
          onClick={() => handleMeas(val.id)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <AccessibilityRounded className="fs-20 m-2" />
        </IconButton>
      </Tooltip>
      <Freezing value={val} />
      <Tooltip title={t("Delete")}>
        <IconButton
          onClick={() => handleDlt(val.id)}
          size="small"
          color="error"
          className="mr-5 p-5"
        >
          <ClearRounded className="fs-20 m-2" />
        </IconButton>
      </Tooltip>
    </div>
  );

  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>{t("AddMember")}</Button>
    </div>
  );

  const AccStatus = ({ status }) => {
    switch (status) {
      case 1:
        return (
          <span className="fs-12 fw-5 bg-success white-color pl-5 pr-5 pt-2 pb-2 w-fit br-8 tx-upp">
            {t("Active")}
          </span>
        );
      case 2:
        return (
          <span className="fs-12 fw-5 bg-warning white-color pl-5 pr-5 pt-2 pb-2 w-fit br-8 tx-upp">
            {t("Freeze")}
          </span>
        );
      case 3:
        return (
          <span className="fs-12 fw-5 bg-graySM pl-5 pr-5 pt-2 pb-2 w-fit br-8 tx-upp">
            {t("NoPlan")}
          </span>
        );
      case 4:
        return (
          <span className="fs-12 fw-5 bg-error white-color pl-5 pr-5 pt-2 pb-2 w-fit br-8 tx-upp">
            {t("Expired")}
          </span>
        );
      default:
        break;
    }
  };

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "member", label: t("Member") },
          { id: "contact", label: t("Contact") },
          { id: "membership", label: t("Membership") },
          { id: "billing", label: t("BillingStatus") },
          { id: "age", label: t("Age") },
          { id: "date", label: t("Date") },
          { id: "actions", label: t("Actions") },
        ]}
        tblData={members.map((j) => {
          var activeInv = invs.find((x) => x.invStatus === 1);

          var invAmt = 0;
          var paidAmt = 0;
          var leftAmt = 0;
          var duration = 0;
          if (j.invs) {
            // Get Duration
            duration = j.invs
              .map((x) =>
                moment(x.endDate, "MM/DD/YYYY").diff(
                  moment(
                    new Date(x.endDate) >= new Date()
                      ? x.startDate
                      : new Date(),
                    "MM/DD/YYYY"
                  ),
                  "days"
                )
              )
              .reduce((x, y) => x + y, 0);

            invAmt = j.invs.map((x) => x.amount).reduce((x, y) => x + y, 0);
            paidAmt = j.invs.map((x) => x.paidAmt).reduce((x, y) => x + y, 0);
            leftAmt = invAmt - paidAmt;
          }
          return {
            ...j,
            member: (
              <div className="d-flex mt-5 mb-5">
                <div className="mr-20">
                  <Avatar src={j.photo} className="shadow-lg" />
                </div>
                <div className="d-grid">
                  <span
                    className="fw-5 primary-color c-pointer mb-3"
                    onClick={() => handleView(j.id)}
                  >
                    {j.firstName + " " + j.lastName}
                  </span>
                  <AccStatus status={j.accStatus} />
                </div>
              </div>
            ),
            contact: (
              <div className="d-grid ">
                <a
                  className="fs-14 primary-color c-pointer mb-3"
                  href={`mailto:${j.email}`}
                >
                  ✉️ {j.email}
                </a>
                <a
                  className="fs-14 primary-color c-pointer"
                  href={`tel:1955206146`}
                >
                  📞 {j.mobile}
                </a>
              </div>
            ),
            age: (
              <div className="d-grid ">
                <span className="fs-16 fw-5 gray-color c-pointer">
                  {j.dob && moment().diff(moment(j.dob, "MM/DD/YYYY"), "years")}
                </span>
                <span className="fs-12 fw-4 gray-color c-pointer">{j.dob}</span>
              </div>
            ),
            membership: (
              <div className="d-grid ">
                <span className="fs-16 fw-5 gray-color c-pointer">
                  {activeInv && activeInv.title}
                </span>
                <span className="fs-12 fw-4 gray-color c-pointer">
                  {t("ExpiresIn")} <span className="fw-6">{duration}</span>{" "}
                  {t("Days")}
                </span>
              </div>
            ),
            billing: j.invs && (
              <div className="fs-12 d-flex a-center g-5 fw-6">
                <div className="d-grid g-2 w-fit">
                  <span className="success-color">
                    {t("Paid")}:&nbsp;&nbsp;{paidAmt}&nbsp;
                    {branch && branch.currency}
                  </span>
                  <Divider />
                  <span className="primary-color">
                    {t("Total")}:&nbsp;&nbsp;{invAmt}&nbsp;
                    {branch && branch.currency}
                  </span>
                </div>
                <span className="error-color">
                  {t("Due")}:&nbsp;&nbsp;
                  {leftAmt}
                  &nbsp;
                  {branch && branch.currency}
                </span>
              </div>
            ),
            date: (
              <div className="d-grid fs-12 g-5 w-fit">
                <span>
                  <span className="fw-5">{t("LastPaid")}:</span>{" "}
                  {j.inv && j.inv.paidDate}
                </span>
                <span>
                  <span className="fw-5">{t("LastVisit")}:</span> {j.lastVisit}
                </span>
              </div>
            ),
          };
        })}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />

      {/* Unfreeze */}
      {showUnfreeze && (
        <Dialog show={showUnfreeze} onClose={false} maxWidth="sm">
          <UnfreezeForm
            {...{
              setShowForm: setShowUnfreeze,
              setAlert,
              member: memberDtls,
              setMembers,
            }}
          />
        </Dialog>
      )}
    </>
  );
};

export default Members;
